<h3 class="heading__regular--xs udex-mb-20">{{'registration.customerName.heading' | cxTranslate}}</h3>

<p class="body--m text-grey udex-mb-20">{{'registration.customerName.subheading' | cxTranslate}}</p>

<form [formGroup]="form">
  <udex-text-field
    required
    class="d-block udex-mb-24"
    [label]="'registration.label.firstName' | cxTranslate"
    [value]="form.get('firstName').value"
    [valueState]="firstName().errorState"
    [supportingText]="firstName().message"
    (input)="onInput($event, 'firstName')">
  </udex-text-field>

  <udex-text-field
    required
    class="d-block udex-mb-24"
    [label]="'registration.label.lastName' | cxTranslate"
    [value]="form.get('lastName').value"
    [valueState]="lastName().errorState"
    [supportingText]="lastName().message"
    (input)="onInput($event, 'lastName')">
  </udex-text-field>
</form>

<p class="body--xs text-blue-gray udex-mb-20">{{'registration.customerName.addingCompanyDisclaimer'| cxTranslate}}</p>

<div class="d-flex">
  <udex-button
    size="Large"
    design="Secondary"
    (click)="goBack()"
    data-cy="back-button">
    {{'common.back' | cxTranslate}}
  </udex-button>

  <udex-button
    [disabled]="form.invalid"
    id="continueButton"
    class="udex-ms-16"
    size="Large"
    design="Primary"
    type="submit"
    (click)="onSubmit()"
    data-cy="submit-button">
    @if (form.disabled) {
      <dcp-loading-indicator/>
    } @else {
      {{'common.continue' | cxTranslate}}
    }
  </udex-button>
</div>
